module.exports = __webpack_public_path__ + "static/media/bottom-sheet-image.39cee4a3.webp";